import DeleteViewModal from './DeleteViewModal';

export default DeleteViewModal;
